import React from "react";

import isIntuit from "Intuit/isIntuit";
import { useDispatch, connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { addPlanToCart } from "Common/CartService";
import Header from "Cobalt/Header";

import { LifePlanEligibilityMessage } from "./shoppingCartSection/LifePlanEligibility";

const ConfirmRemovePlanModalDumb = ({ plan, onHide, show }) => {
  const dispatch = useDispatch();

  const removePlanAndLifePlan = async () => {
    await dispatch(addPlanToCart({ planType: plan.type, plan: null }));
    await dispatch(addPlanToCart({ planType: "life", plan: null }));
    await AnalyticsTracking.trackEvent("plan_removed", {
      type: plan.type,
      deprecatedName: `remove-plan/${plan.type}`,
    });

    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <ModalHeader closeButton>
        <Header level={7}>Remove Plan?</Header>
      </ModalHeader>
      <ModalBody>
        <BodyText>
          Without this plan, you will not meet eligibility requirements for life insurance.
          <br />
          {LifePlanEligibilityMessage}
        </BodyText>
      </ModalBody>
      <ModalFooter>
        <Button color="gray" mr={3} onClick={onHide} {...(isIntuit() ? { size: "medium" } : {})}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            removePlanAndLifePlan();
          }}
          {...(isIntuit() ? { size: "medium" } : {})}
        >
          Remove Plan
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (_state, ownProps) => ({
  onHide: ownProps.onHide,
  show: ownProps.show,
});

const withRedux = connect(mapStateToProps);

export default withRedux(ConfirmRemovePlanModalDumb);
